// extracted by mini-css-extract-plugin
module.exports = {"pageControl":"previousFeedback_pageControl__32xFY"};